const API_BASE = process.env.REACT_APP_BACKEND_URL || '/api';

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

async function handleResponse(res) {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const error = new Error(body.message || body.error || `Request failed (${res.status})`);
    error.status = res.status;
    error.body = body;
    throw error;
  }
  return res.json();
}

export const subscriptionApi = {
  getPlans: () =>
    fetch(`${API_BASE}/subscriptions/plans`).then(handleResponse),

  getCurrentSubscription: () =>
    fetch(`${API_BASE}/subscriptions/current`, { headers: authHeaders() }).then(handleResponse),

  initiateCheckout: (planId, provider) =>
    fetch(`${API_BASE}/subscriptions/checkout`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({
        plan_id: planId,
        provider,
        success_url: `${window.location.origin}/subscription/success`,
        cancel_url: `${window.location.origin}/subscription/cancel`,
      }),
    }).then(handleResponse),

  completeCheckout: (sessionId) =>
    fetch(`${API_BASE}/subscriptions/checkout/complete`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ session_id: sessionId }),
    }).then(handleResponse),

  cancelSubscription: (immediate = false) =>
    fetch(`${API_BASE}/subscriptions/cancel`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ immediate }),
    }).then(handleResponse),

  changePlan: (newPlanId) =>
    fetch(`${API_BASE}/subscriptions/change-plan`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ new_plan_id: newPlanId }),
    }).then(handleResponse),

  reactivate: () =>
    fetch(`${API_BASE}/subscriptions/reactivate`, {
      method: 'POST',
      headers: authHeaders(),
    }).then(handleResponse),

  getBillingHistory: () =>
    fetch(`${API_BASE}/subscriptions/billing-history`, { headers: authHeaders() }).then(handleResponse),

  getPortalUrl: () =>
    fetch(`${API_BASE}/subscriptions/portal`, {
      method: 'POST',
      headers: authHeaders(),
    }).then(handleResponse),

  getEntitlements: () =>
    fetch(`${API_BASE}/subscriptions/entitlements`, { headers: authHeaders() }).then(handleResponse),
};
